import type { Api_Feed, Api_Playlist_Collection } from '@core/api'

/**
 *
 */
export const isVideoCollectionFeed = (
  feed?: Api_Feed | Api_Playlist_Collection | null,
): feed is Api_Playlist_Collection => {
  return Boolean(feed && 'playlists' in feed)
}

/**
 *
 */
export const isVideoFeed = (
  feed?: Api_Feed | Api_Playlist_Collection | null,
): feed is Api_Feed => {
  return Boolean(feed && 'feed_items' in feed)
}
